import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import { bindActionCreators } from 'redux';

import {
    Row,
    Link,
} from 'yurstrap';

import {
    openModal,
} from '../reduxModules/ConsentManagementPlatform';

const propTypes = {
    AppActions: PropTypes.shape({
        openModal: PropTypes.func.isRequired,
    }).isRequired,
};

class CMPFacebookPortal extends Component {

    constructor(props) {
        super(props);
        this.onOpenModal = this.onOpenModal.bind(this);
        this.element = document.createElement('div');
    }

    componentDidMount() {
        if (document.querySelector('#js-app-cmp-facebook-info')) {
            document.querySelector('#js-app-cmp-facebook-info').appendChild(this.element);
        }
    }

    componentWillUnmount() {
        if (document.querySelector('#js-app-cmp-facebook-info')) {
            document.querySelector('#js-app-cmp-facebook-info').removeChild(this.element);
        }
    }

    onOpenModal() {
        const { AppActions } = this.props;
        AppActions.openModal();
    }

    renderCookieAccepted() {
        return (
            <a className="facebook-login c-link c-link--primary" data-perms="manage_pages">
                Autoriser Yurplan a accéder aux évènements de vos pages Facebook ?
            </a>
        );
    }

    renderCookieRefused() {
        return (
            <Row vcenter>
                Pour activer les fonctionnalités liées à Facebook, vous devez accepter
                le dépôt du cookie Facebook, dans la catégorie Fonctionnalités.
                Pour se faire, rendez-vous dans votre espace
                <Link
                    onClick={this.onOpenModal}
                >
                    Gestion des cookies.
                </Link>
            </Row>
        );
    }

    renderPortalContent() {
        if (document.cookie.indexOf('FACEBOOK_CONNEXION') > -1) return this.renderCookieAccepted();
        return (
            <>
                {this.renderCookieRefused()}
            </>
        );
    }

    render() {
        return ReactDOM.createPortal(
            this.renderPortalContent(),
            this.element,
        );
    }

}

CMPFacebookPortal.propTypes = propTypes;

function mapDispatchToProps(dispatch) {
    return {
        AppActions: bindActionCreators({
            openModal,
        }, dispatch),
    };
}

export default connect(
    undefined,
    mapDispatchToProps,
)(CMPFacebookPortal);
